const preferences = {
  appLanguage: {
    helpText: "Met à jour la langue de l'application lorsque la localisation est disponible.",
    label: "Langue de l'application",
    options: {
      en: 'Anglais',
      enUS: 'Anglais (États-Unis)',
      enGB: 'Anglais (Royaume-Uni)',
      enCA: 'Anglais (Canada)',
      es: 'Espagnol',
      esMX: 'Espagnol (Mexique)',
      fr: 'Français',
      frCA: 'Français (Canada)',
    },
    useDeviceLanguage: "Utiliser la langue de l'appareil",
  },
  assistantReplies: {
    helpText: "S'applique uniquement aux nouvelles réponses de l'assistant.",
    label: "Réponses de l'assistant",
    matchAppLanguage: "Utiliser la langue de l'application",
  },
  errors: {
    loadFailed: 'Impossible de charger les préférences.',
    saveFailed: "Impossible d'enregistrer ce paramètre.",
  },
  savedPrompts: {
    actions: {
      delete: 'Supprimer le prompt',
      edit: 'Modifier le prompt',
      moveDown: 'Déplacer le prompt vers le bas',
      moveUp: 'Déplacer le prompt vers le haut',
      new: 'Nouveau prompt',
      send: 'Envoyer le prompt',
    },
    ariaLabel: 'Prompts enregistrés',
    deleteDialog: {
      confirmation: 'Supprimer <strong>{{title}}</strong> ? Cette action est irréversible.',
      deleting: 'Suppression...',
      title: 'Supprimer le prompt enregistré ?',
    },
    editor: {
      cancel: 'Annuler',
      discardChanges: 'Ignorer les modifications',
      discardChangesMessage: 'Vos modifications non enregistrées seront perdues.',
      discardChangesTitle: 'Ignorer les modifications ?',
      editTitle: 'Modifier le prompt enregistré',
      keepEditing: 'Continuer la modification',
      newTitle: 'Nouveau prompt enregistré',
      save: 'Enregistrer le prompt',
      saving: 'Enregistrement...',
    },
    empty: 'Aucun prompt enregistré pour le moment',
    errors: {
      createFailed: 'Impossible de créer ce prompt.',
      deleteFailed: 'Impossible de supprimer ce prompt.',
      loadFailed: 'Impossible de charger les prompts enregistrés.',
      reorderFailed: 'Impossible de réordonner ce prompt.',
      saveFailed: "Impossible d'enregistrer ce prompt.",
      updateFailed: 'Impossible de mettre à jour ce prompt.',
    },
    form: {
      characterCount_one: '{{count}} / {{maximum}} caractère',
      characterCount_other: '{{count}} / {{maximum}} caractères',
      promptTextLabel: 'Prompt',
      titleLabel: 'Titre',
    },
    fromResponse: {
      action: 'Enregistrer comme prompt',
      error: 'Impossible de préparer un prompt enregistré. Veuillez réessayer.',
      preparing: 'Préparation du prompt...',
    },
    loading: 'Chargement des prompts enregistrés',
    validation: {
      promptTextMax: 'Le texte du prompt doit comporter {{maximum}} caractères ou moins.',
      promptTextRequired: 'Le texte du prompt est requis.',
      titleMax: 'Le titre doit comporter {{maximum}} caractères ou moins.',
      titleRequired: 'Un titre est requis.',
    },
  },
  settings: {
    ariaLabel: 'Paramètres utilisateur',
    loading: 'Chargement des paramètres',
    saving: 'Enregistrement des paramètres',
  },
} as const;

export default preferences;